import { CheckCircle, XCircle } from "lucide-react";

function getValidationStatus(password, confirmPassword) {
  return {
    minLength: password.length >= 8,
    specialChar: /[!@#$%^&*]/.test(password),
    number: /\d/.test(password),
    capital: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    match: password !== "" && password === confirmPassword,
  };
}

export default function ResetPasswordChecklist({ password, confirmPassword, onChange }) {
  const status = getValidationStatus(password, confirmPassword);
  const isValid = Object.values(status).every((v) => v === true);
  if (onChange) onChange(isValid);

  const items = [
    { key: "minLength", label: "Minimum 8 characters" },
    { key: "specialChar", label: "At least 1 special character (!@#$%^&*)" },
    { key: "number", label: "At least 1 number" },
    { key: "capital", label: "At least 1 uppercase letter" },
    { key: "lowercase", label: "At least 1 lowercase letter" },
    { key: "match", label: "Passwords match" },
  ];

  return (
    <div className="mt-4 space-y-1 text-sm">
      {items.map((item) => (
        <div
          key={item.key}
          className={`flex items-center gap-2 ${
            status[item.key] ? "text-green-600" : "text-red-500"
          }`}
        >
          {status[item.key] ? (
            <CheckCircle className="w-4 h-4" />
          ) : (
            <XCircle className="w-4 h-4" />
          )}
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
